import React from 'react';

import Concerts from 'features/tours/Concerts';

interface ConcertsPageProps {
  isConcertsFestivals?: boolean
}

const ConcertsPage = ({ isConcertsFestivals }: ConcertsPageProps) => {
  return (
    <Concerts isConcertsFestivals={isConcertsFestivals} />
  );
};

export default ConcertsPage;
